module.exports = __webpack_public_path__ + "static/img/face09.01557b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/face09.jpg
// module id = jDeX
// module chunks = 0